const AUTH_TOASTS = {
   SIGNIN_SUCCESFUL: "Login successful",
   SIGNIN_UNSUCCESFUL: "Failed to login!",
   REGISTER_SUCCESFUL: "User succesfully registered!",
   REGISTER_UNSUCCESFUL: "Failed to register user"
    
}
export default AUTH_TOASTS